import Vue from "vue";
    import ApiButton from "@/components/ApiButton.vue";
    import Component from "vue-class-component";
    import { ApiClient } from "@/utilities/ApiClient";
    import { Watch } from "vue-property-decorator";
    import * as toastr from "toastr";
    import { BookingVM } from "@/model/Api/VM/BookingVM";
    import { Utils } from "@/utilities/Utils";
    import { Employee, IEmployee } from "@/model/Employee";

    @Component({
        components: {
            ApiButton
        }
    })

    export default class SubmitBookingModal extends Vue {

        private checkboxStatus: string = "false"
        private booking = new BookingVM();
        private isDisabled: boolean = true;
        private employees: Array<IEmployee> = [];

        @Watch("checkboxStatus")
        onChanged(value: any) {
            if (this.checkboxStatus === "true") {
                this.isDisabled = false
            }
            if (this.checkboxStatus === "false") {
                this.isDisabled = true
            }
        }

        show(booking: BookingVM, employees: Array<IEmployee>) {
            this.employees = employees;
            this.booking = booking;
            this.$bvModal.show("submitBookingModal")
        }

        cancel() {
            this.$bvModal.hide("submitBookingModal")
        }

        async submitRequest(event: Event) {

            const checkStatus = new BookingVM()
            const getStatus = await await ApiClient.get(`api/booking/GetBooking?id=${this.booking.id}`);
            checkStatus.update(getStatus)

            if (checkStatus.statusID < 2) {
                this.booking.statusID = 2;
            }

            const postData = { booking: this.booking, }

            const saveResponse = await ApiClient.post("/Api/Booking/SaveBooking", this.booking, event);
            if (saveResponse.message === "ok") {
                this.sendSubmitRequestEmail();
                toastr.success("Request submitted");
                this.$emit("refreshSearch");
                Utils.resetObject(this.booking);
                this.$bvModal.hide("submitRequest");
                this.$bvModal.hide("bookingModal");
            }   
        }

        async sendSubmitRequestEmail() {
            const response = await ApiClient.post("/Api/Booking/sendSubmitRequestEmail", this.booking);
            if (response.message === "ok") {
                toastr.success("Submit Request email sent");
            }
            else {
                toastr.error(response.message);
            }
        }

    }
    
